<script>
import Closed from "./Componets/Closed.svelte";
import WorkingHours from "./Componets/WorkingHours.svelte";

let today = new Date();
let time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();

</script>

<main>
	{#if today.getHours() > 18 }
		<Closed />
	{:else if today.getHours() < 8 }
		<Closed />
	{:else}
		<WorkingHours />
	{/if}
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		margin: 0 auto;
	}
</style>